<template>
    <b-container fluid class="py-3">
        <b-row>
            <b-col>
                <!-- {{ items }} -->
                <Tableview :value="items" :paginator="true" class="p-datatable-gridlines" :rows="10" :rowHover="true"
                    filterDisplay="menu" :loading="loading" responsiveLayout="scroll" :columns="headers"
                    :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single" dataKey="Id">
                    <template v-slot:Status="{ data }">
                        <RedStatus name="InActive" v-if="data.IsActive == '0'" />
                        <GreenStatus name="Active" v-if="data.IsActive == '1'" />
                    </template>
                    <template v-slot:Add>
                        <span class="add">
                            <AddButton :btnname="$t('btn.plusaddnew')" class="float-rights my-3" @click="IsAdd">
                            </AddButton>
                        </span>
                    </template>
                    <template v-slot:action="{ data }">
                        <span>
                            <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                                @click="toggle($event, data)" />
                        </span>
                    </template>
                </Tableview>
                <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
            </b-col>
        </b-row>
    </b-container>

    <Dialog v-model:visible="createpop" modal header="Enter UIN Number" :style="{ width: '25rem' }">
        <b-container fluid>
            <b-row>
                <b-col lg="12" md="12" sm="12" cols="12" class="field">

                    <label>UIN Number</label>
                    <AutoCompleteCustom v-model="datamodel.uinnumber" :items="datamodel.UINOption"
                        @keydown="LoadUINNumber" class="autoItem" @item-select="UINNumberSelect" name="uinnumber"
                        id="uinnumber" />
                </b-col>

            </b-row>
            <!-- <b-row>
                <b-col>
                    <Button label="Get Details" class="float-end getdetailsbtn" @click="IssuePop" />
                </b-col>
            </b-row> -->
        </b-container>
    </Dialog>

    <ItemAllocatioNPopup v-model:showIOLDialog="showIOLDialog" v-if="showIOLDialog" :showitems="showitems"
        @closepopup=isClear :PatientDetails="PatientDetails" />
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, watch } from 'vue'
import moment from "moment";

import { useRoute, useRouter } from "vue-router";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import ItemAllocatioNPopup from "../../../../../modules/Inventory/pages/Transaction/PatientIssue/ItemAllocationPopup.vue"
import TextField from "../../../../../components/FormComponents/TextInput.vue"
import AutoCompleteCustom from "../../../../../components/FormComponents/AutoComplete.vue";

import PatientIssueService from "../../../../../modules/Inventory/Service/PatientIssueService"


export default defineComponent({
    components: {
        Tableview,
        ItemAllocatioNPopup,
        TextField,
        AutoCompleteCustom
    },
    props: {
        FilterObj: {
            type: Object,
            default: {}
        },
    },
    setup(props, { emit }) {

        const route = useRoute();
        const router = useRouter();

        let items = ref([]);

        let ActionToggleDetails = ref<{
            StockOutId: number | 0;
        }>({
            StockOutId: 0
        });

        let PatientDetails = ref({})

        const loading = ref(false);
        const showIOLDialog = ref(false);
        const createpop = ref(false);
        const menu = ref();
        const showitems = ref('');

        let SessionUserData = localStorage.getItem("UsersData");
        let usersData;
        if (SessionUserData !== null) {
            usersData = JSON.parse(SessionUserData);
        }

        let SessionRolesData = localStorage.getItem("RolesData");
        let rolesData;
        if (SessionRolesData !== null) {
            rolesData = JSON.parse(SessionRolesData);
        }

        interface UIN {
            uin: string;
            mrno: string;
            ipano: string;
            patientName: string;
            nextOfKin: string;
            eye: string;
            surgery: string;
            lens: string;
            admissionDate: string;
            siteId: number | 0;
            patientType: string;
            iolPower: string;
            paymentType: string;

            label: string;
            value: string;
        }

        const datamodel = ref<{
            uinnumber: string;
            UINOption: UIN[];
            GetAdmittedPatientSurgeryListArray: UIN[];
        }>({
            uinnumber: "",
            UINOption: [],
            GetAdmittedPatientSurgeryListArray: []
        });

        const toggle = (event, data) => {
            debugger;
            menu.value.toggle(event);
            ActionToggleDetails.value = data;
        };

        function IsAdd() {
            debugger;
            // createpop.value = true;

            router.push({
                name: "ItemIssueCreation",
                query: {
                    Param: "issue",
                    StoreId: Number(route.query.Id),
                    BranchId: Number(route.query.BranchId),
                    storebranchmapid: Number(route.query.storebranchmapid),
                    SiteId: route.query.SiteId || 0,
                },
            });
        }

        const itemListed = ref([
            {
                items: [
                    {
                        label: "Issue Standby Lens",
                        visible: true,
                        command: async () => {
                            IssueStandbyLens();
                        },
                    },
                    // {
                    //     label: "Update Consumption",
                    //     visible: true,
                    //     command: async () => {
                    //         UpdateConsumption();
                    //     },
                    // },
                ],
            },
        ]);

        //DataTable Fields
        const headers = [
            {
                header: "S.No",
                field: "RowNumber",
                class: 'filterdisplaynone'
            },
            {
                header: "Issue No",
                field: "DocNo",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
                bodyclass: 'boldclass',
            },
            {
                header: "Date",
                field: "DocDate",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: 'To Name',
                field: 'ToStoreName',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
            },
            {
                header: 'Patient Count',
                field: 'PatientCount',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
            },
            {
                header: 'Consumed Count',
                field: 'ConsumedCount',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
            }, {
                header: 'Returned Count',
                field: 'ReturnedCount',
                filterTemplate: 'MultiSelect',
                ShowMactchMode: false,
            },
            {
                field: "action",
                header: "",
                slot: "action",
                frozencolumn: true,
                sortable: false,
                class: "filterdisplaynone last-column-position",
                fieldDisplay: "false",
            },
        ];

        function isClear() {
            showIOLDialog.value = false;
        }

        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            Code: { value: null, matchMode: FilterMatchMode.IN, options: items },
            TemplateInfo: { value: null, matchMode: FilterMatchMode.IN, options: items },
        };

        const filteredColumns = computed(() => {
            return headers.filter((col) => col.field !== "id");
        });

        const globalFilterFields = ref(headers.map((col) => col.field));

        onMounted(() => {
            ReadyFunction();
        });

        const ReadyFunction = async () => {
            debugger;
            await LoadIssueTable();
            GetAdmittedPatientSurgeryList();
        }

        interface IssueObj {
            HospitalId: number | 0;
            BranchId: number | 0;
            StoreId: number | 0;
            StoreBrMapId: number | 0;
            DocType: string;
            Date: string;
        }

        const IssueObj = ref<IssueObj>({
            HospitalId: usersData.OrganizationId,
            BranchId: Number(route.query.BranchId),
            StoreId: Number(route.query.Id),
            StoreBrMapId: Number(route.query.storebranchmapid),
            DocType: "22",
            Date: moment().format("YYYY-MM-DD")
        })

        const LoadIssueTable = async (): Promise<void> => {
            debugger;
            try {

                const response = await PatientIssueService.GetIOLStockOut(IssueObj.value);

                let RowNumber = 0;
                items.value = response["result"].map((x) => {
                    RowNumber = RowNumber + 1
                    x.RowNumber = RowNumber;
                    x.uin = x.PatientId;
                    x.iolPower = x.RequiredLens;
                    x.StockOutId = x.Id;
                    x.StockOutDocNo = x.DocNo;
                    return x;
                });

            } catch (error) {
                console.error('Error loading Issue table:', error);
            }
        }

        watch(
            () => [props.FilterObj.Date],
            ([newFilterObj]) => {
                debugger;
                if (newFilterObj) {
                    IssueObj.value.Date = newFilterObj;
                    LoadIssueTable();
                }
            },
            { immediate: true }
        );

        interface obj {
            Date: string;
            SiteId: number | 0
        }

        const Obj = ref<obj>({
            Date: "2024-01-11",
            // Date: moment().format("YYYY-MM-DD"),
            SiteId: Number(route.query.SiteId) || 0
        })

        const GetAdmittedPatientSurgeryList = async (): Promise<void> => {
            debugger;
            try {

                const response = await PatientIssueService.GetAdmittedPatientSurgeryList(Obj.value);

                datamodel.value.GetAdmittedPatientSurgeryListArray = response["result"];

            } catch (error) {
                console.error('Error loading admited patient list:', error);
            }
        }

        const LoadUINNumber = () => {
            debugger;
            let SearchText = datamodel.value.uinnumber;

            let regex = new RegExp(SearchText, "i");

            datamodel.value.UINOption = datamodel.value.GetAdmittedPatientSurgeryListArray.filter(
                (x) => regex.test(x.uin) || regex.test(x.patientName)
            ).map((y) => {
                y.label = y["uin"] + ' - ' + y['patientName'];
                y.value = y["uin"];
                return y;
            })
        }

        const UINNumberSelect = () => {
            debugger;

            let PatientObj = datamodel.value.GetAdmittedPatientSurgeryListArray.filter(
                (x) => x.uin == datamodel.value.uinnumber["uin"]
            )

            PatientDetails.value = PatientObj[0];
            datamodel.value.uinnumber = "";
            IssuePop();
        }


        const IssueStandbyLens = () => {
            showitems.value = 'issuestandbylens';
            // PatientDetails.value = ActionToggleDetails.value;
            // showIOLDialog.value = true;

            router.push({
                name: "ItemIssueCreation",
                query: {
                    Param: "issuestandbylens",
                    StockOutId: Number(ActionToggleDetails.value.StockOutId),
                    StoreId: Number(route.query.Id),
                    ToStoreId: Number(route.query.Id),
                    BranchId: Number(route.query.BranchId),
                    storebranchmapid: Number(route.query.storebranchmapid),
                    Date: IssueObj.value.Date
                },
            });
        }

        const UpdateConsumption = () => {
            showitems.value = 'updateconsumption';
            PatientDetails.value = ActionToggleDetails.value;
            showIOLDialog.value = true;
        }

        const IssuePop = () => {
            showitems.value = 'issue';
            showIOLDialog.value = true;
        }

        return {
            items,
            loading,
            filteredColumns,
            globalFilterFields,
            headers,
            filters,
            toggle,
            menu,
            itemListed,
            showIOLDialog,
            isClear,
            showitems,
            createpop,
            IsAdd,
            datamodel,
            IssuePop,
            LoadUINNumber,
            UINNumberSelect,
            PatientDetails
        }
    }

})
</script>

<style lang="scss" scoped>
.getdetailsbtn {
    all: unset;
}
</style>